import axios from 'axios';

const imageCache = new Map();

const FILE_BASE_URL = (process.env.VUE_APP_FILE_BASE_URL || 'https://xc.hehuitech.cn/water-file').replace(/\/$/, '')

const LEGACY_FILE_HOSTS = [
  'http://139.159.216.240:9000',
  'https://139.159.216.240:9000'
]

/**
 * 将后端返回的文件地址转换为可访问的域名地址
 * @param {string} url 原始文件地址
 * @returns {string}
 */
export function resolveFileUrl (url) {
  if (!url) return url

  if (url.startsWith(FILE_BASE_URL)) {
    return url
  }

  for (const host of LEGACY_FILE_HOSTS) {
    if (url.startsWith(host)) {
      const path = url.slice(host.length)
      return `${FILE_BASE_URL}${path.startsWith('/') ? path : `/${path}`}`
    }
  }

  if (url.startsWith('/')) {
    return `${FILE_BASE_URL}${url}`
  }

  if (/^https?:\/\//.test(url)) {
    try {
      const parsed = new URL(url)
      return `${FILE_BASE_URL}${parsed.pathname}${parsed.search || ''}`
    } catch (error) {
      return url
    }
  }

  return `${FILE_BASE_URL}/${url.replace(/^\/+/, '')}`
}

/**
 * 同步获取缓存的图片 Base64（如果已缓存）
 * @param {string} url 图片地址
 * @returns {string|null} Base64 字符串，如果未缓存则返回 null
 */
export function getCachedImageBase64 (url) {
  if (!url) return null;
  if (imageCache.has(url)) {
    return imageCache.get(url);
  }
  return null;
}

/**
 * 将图片 URL 转换为 Base64 字符串并缓存
 * @param {string} url 图片地址
 * @returns {Promise<string>} Base64 字符串
 */
export async function getImageBase64 (url) {
  if (!url) return '';
  if (imageCache.has(url)) {
    return imageCache.get(url);
  }

  // 如果已经是 base64，直接返回
  if (url.startsWith('data:image')) {
    return url;
  }

  try {
    // 使用 axios 获取 blob，这样可以更好地处理请求
    const response = await axios.get(url, { responseType: 'blob' });
    const blob = response.data;

    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64data = reader.result;
        imageCache.set(url, base64data);
        resolve(base64data);
      };
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  } catch (error) {
    console.error('Failed to convert image to base64:', error);
    // 如果失败，返回原始 URL，让浏览器尝试正常加载
    return url;
  }
}
